import { render, staticRenderFns } from "./DeleteUserCard.vue?vue&type=template&id=131bd91c"
import script from "./DeleteUserCard.vue?vue&type=script&lang=js"
export * from "./DeleteUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports